<template>
    <div>
        <div v-if="erro">
            <SemPermissao></SemPermissao>
        </div>
        <template v-if="!erro">
            <RespostaForm :resposta="null" />
        </template>
    </div>
</template>

<script>

    import RespostaForm from '../../components/respostas/RespostaForm.vue';
    import SemPermissao from "../SemPermissao.vue"

    export default {
        name: "RespostaNew",
        data() {
            return {
                erro: false,
            };
        },
        components: {
            SemPermissao,
            RespostaForm,
        },
    };
</script>

<style lang="scss" scoped>
</style>